import React from 'react';
import './CartPickerTitle.less';

export const CartPickerTitle = ({text}) => {
	return <label className="cart-picker-title">{text}</label>;
};
